<template lang="html">
  <div>
    <b-row>
      <b-col class="mt-5">
        <b-row>
          <b-col md="1">
            <VerticalButtons
              id="toolbar"
              :value="$store.state.overlays.overlay_tool_value"
              :options="$store.state.overlays.overlay_tool_options"
              class="d-none d-lg-block d-xl-block"
              @changed="v => value_changed('overlay_tool_value', v)"
            />
          </b-col>
          <b-col lg="5" md="10">
            <TabButtonsString
              :value="$store.state.overlays.overlay_tool_value"
              :options="$store.state.overlays.overlay_tool_options"
              :show-text="false"
              label="Overlay tool"
              class="mb-2 d-block d-lg-none"
              @changed="v => value_changed('overlay_tool_value', v)"
            />
            <OverlayTextColor
              v-if="activeOverlay.type == 'text_color'"
              :overlay="activeOverlay"
            />
            <OverlayShape
              v-if="activeOverlay.type == 'rect'"
              :overlay="activeOverlay"
            />
            <OverlayShape
              v-if="activeOverlay.type == 'circle'"
              :overlay="activeOverlay"
            />
          </b-col>
          <b-col lg="5" md="10" offset="1">
            <div
              v-for="overlay in overlays"
              :key="overlay.id"
              class="mt-2 small"
            >
              <p v-if="overlay.type == 'text_color'" class="mb-0">
                {{ overlay.text | truncate(60, "...") }}
              </p>
              <p v-if="overlay.type == 'rect'" class="mb-0">
                Rectangle shape overlay
              </p>
              <p v-if="overlay.type == 'circle'" class="mb-0">
                Ellipse shape overlay
              </p>
              <p class="mt-0">
                <b-link
                  v-if="overlay.type != 'start_button'"
                  size="sm"
                  @click="activateOverlay(overlay)"
                >
                  Edit
                </b-link>

                <b-link
                  v-if="overlay.type != 'start_button'"
                  size="sm"
                  @click="removeOverlay(overlay)"
                >
                  Remove
                </b-link>
                <span class="text-muted small">{{ overlay.id }}</span>
              </p>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import find from "lodash/find";
import TabButtonsString from "@/components/show/inspectors/ui/TabButtonsString";
import OverlayTextColor from "@/components/show/inspectors/OverlayTextColor";
import OverlayShape from "@/components/show/inspectors/OverlayShape";
import VerticalButtons from "@/components/show/inspectors/ui/VerticalButtons";
export default {
  name: "ShowOverlays",
  components: {
    TabButtonsString,
    OverlayTextColor,
    OverlayShape,
    VerticalButtons
  },
  props: {
    currentTime: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {};
  },
  computed: {
    show() {
      return this.$store.state.show.currentShow;
    },
    overlays() {
      return this.show.data?.overlayArray;
    },
    activeOverlay() {
      var activeOverlay = find(this.overlays, {
        id: this.$store.state.overlays.activeEditOverlayId
      });
      if (activeOverlay) {
        return activeOverlay;
      }
      return {};
    }
  },
  watch: {
    show(value) {
      console.log(value);
    }
  },
  mounted() {},
  methods: {
    value_changed(name, value) {
      console.log("Changed", name, value);
      if (name === "overlay_tool_value") {
        this.$store.commit("overlays/setOverlayToolValue", value);
      }
    },
    removeOverlay(overlay) {
      var overlayConfirm = confirm(
        "Are you sure you want to remove this overlay?"
      );
      if (overlayConfirm) {
        this.$store.dispatch("overlays/removeOverlayById", overlay.id);
      }
    },
    activateOverlay(overlay) {
      // Advance to overlay and edit.
      var transition_in_seconds = 1;
      this.$emit("gotoAndPause", overlay.inpoint + transition_in_seconds);
      this.$store.dispatch("overlays/updateActiveEditOverlayId", overlay.id);
    }
  }
};
</script>

<style lang="css" scoped>
#toolbar {
  position: absolute;
  left: -4px;
  top: 14px;
  width: 40px;
}
</style>
